export default class ProductBuilder{
    build(product, quantity) {
        return {
            brand: product.brand,
            category: product.category,
            id: product.id,
            name: product.name,
            price: product.price,
            quantity: quantity
        }
    }
}